import { d as __awaiter, b as __generator, a as __spreadArray, _ as __read, e as __rest, c as __assign } from '../../../../tslib.es6-80f01feb.js';
import { Howl } from 'howler';
import { SoundType } from './types.js';
import { defaultSounds } from './defaultSounds.js';

var SoundService = /** @class */ (function () {
    function SoundService(_a) {
        var _b, _c;
        var options = _a.options;
        var _this = this;
        this.sounds = (_b = {},
            _b[SoundType.Music] = null,
            _b[SoundType.Win] = null,
            _b[SoundType.BetAccepted] = null,
            _b);
        this.soundSourceIds = (_c = {},
            _c[SoundType.Music] = null,
            _c[SoundType.Win] = null,
            _c[SoundType.BetAccepted] = null,
            _c);
        this.musicOptions = [];
        this.soundOptions = [];
        var defaultSoundList = __spreadArray([], __read(defaultSounds), false).filter(Boolean);
        this.options = __spreadArray(__spreadArray([], __read(options), false), __read(defaultSoundList), false);
        this.options.forEach(function (option) {
            if (option.name.includes(SoundType.Music)) {
                _this.musicOptions.push(option);
            }
            else {
                _this.soundOptions.push(option);
            }
        });
    }
    SoundService.prototype.loadResourceVersion2 = function (_a) {
        var language = _a.language;
        return __awaiter(this, void 0, void 0, function () {
            var max, count;
            var _this = this;
            return __generator(this, function (_b) {
                max = this.options.length;
                count = 1;
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.options.forEach(function (_a) {
                            var name = _a.name, getSrc = _a.getSrc, src = _a.src, option = __rest(_a, ["name", "getSrc", "src"]);
                            if (typeof getSrc === 'function') {
                                _this.sounds[name] = new Howl(__assign(__assign({ src: getSrc(language) }, option), { onload: function () {
                                        count++;
                                        if (count === max) {
                                            resolve();
                                        }
                                    }, onloaderror: function () {
                                        _this.sounds[name] = new Howl(__assign(__assign({ src: src }, option), { onload: function () {
                                                count++;
                                                if (count === max) {
                                                    resolve();
                                                }
                                            } }));
                                    } }));
                            }
                            else {
                                _this.sounds[name] = new Howl(__assign(__assign({}, option), { src: src }));
                                _this.sounds[name].once('load', function () {
                                    count++;
                                    if (count === max) {
                                        resolve();
                                    }
                                });
                            }
                        });
                    })];
            });
        });
    };
    SoundService.prototype.loadResource = function (_a) {
        var language = _a.language;
        return __awaiter(this, void 0, void 0, function () {
            var max, count;
            var _this = this;
            return __generator(this, function (_b) {
                max = this.options.length;
                count = 1;
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.options.forEach(function (_a) {
                            var name = _a.name, getSrc = _a.getSrc, src = _a.src, option = __rest(_a, ["name", "getSrc", "src"]);
                            if (typeof getSrc === 'function') {
                                _this.sounds[name] = new Howl(__assign(__assign({ src: getSrc(language) }, option), { onload: function () {
                                        count++;
                                        if (count === max) {
                                            resolve();
                                        }
                                    }, onloaderror: function () {
                                        _this.sounds[name] = new Howl(__assign(__assign({ src: src }, option), { onload: function () {
                                                count++;
                                                if (count === max) {
                                                    resolve();
                                                }
                                            } }));
                                    } }));
                            }
                            else {
                                _this.sounds[name] = new Howl(__assign(__assign({}, option), { src: src, onload: function () {
                                        count++;
                                        if (count === max) {
                                            resolve();
                                        }
                                    } }));
                            }
                        });
                    })];
            });
        });
    };
    SoundService.prototype.init = function (initConfig) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadResource(initConfig)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SoundService.prototype.playWithoutStop = function (name, startTime) {
        if (startTime === void 0) { startTime = 0; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.sounds[name].seek(startTime);
                this.soundSourceIds[name] = this.sounds[name].play();
                return [2 /*return*/];
            });
        });
    };
    SoundService.prototype.play = function (name, startTime) {
        if (startTime === void 0) { startTime = 0; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stop(name)];
                    case 1:
                        _a.sent();
                        if (!this.soundSourceIds[name]) {
                            if (this.sounds[name]) {
                                this.sounds[name].seek(startTime);
                                this.soundSourceIds[name] = this.sounds[name].play();
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    SoundService.prototype.stop = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var id;
            var _this = this;
            return __generator(this, function (_a) {
                id = this.soundSourceIds[name];
                if (id) {
                    return [2 /*return*/, new Promise(function (resolve) {
                            _this.sounds[name].on('stop', function () { return resolve(); });
                            _this.sounds[name].stop(id);
                            _this.soundSourceIds[name] = null;
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    SoundService.prototype.mute = function (name) {
        if (this.sounds[name]) {
            this.sounds[name].mute(true);
        }
    };
    SoundService.prototype.unMute = function (name) {
        if (this.sounds[name]) {
            this.sounds[name].mute(false);
        }
    };
    SoundService.prototype.playMusic = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.play(SoundType.Music)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SoundService.prototype.stopMusic = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stop(SoundType.Music)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SoundService.prototype.playBetAccepted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.play(SoundType.BetAccepted)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SoundService.prototype.stopBetAccepted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stop(SoundType.BetAccepted)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SoundService.prototype.playWin = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.play(SoundType.Win)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SoundService.prototype.stopWin = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.stop(SoundType.Win)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SoundService.prototype.stopAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.options.map(function (_a) {
                            var name = _a.name;
                            return _this.stop(name);
                        }))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SoundService.prototype.muteAll = function () {
        var _this = this;
        this.options.forEach(function (_a) {
            var name = _a.name;
            return _this.mute(name);
        });
    };
    SoundService.prototype.unMuteAll = function () {
        var _this = this;
        this.options.forEach(function (_a) {
            var name = _a.name;
            return _this.unMute(name);
        });
    };
    SoundService.prototype.muteMusic = function (isMute) {
        var _this = this;
        this.musicOptions.forEach(function (_a) {
            var name = _a.name;
            if (_this.sounds[name]) {
                _this.sounds[name].mute(isMute);
            }
        });
    };
    SoundService.prototype.muteSounds = function (isMute) {
        var _this = this;
        this.soundOptions.forEach(function (_a) {
            var name = _a.name;
            if (_this.sounds[name]) {
                _this.sounds[name].mute(isMute);
            }
        });
    };
    SoundService.prototype.changeMusicVolume = function (volume) {
        var _this = this;
        this.musicOptions.forEach(function (_a) {
            var name = _a.name;
            if (_this.sounds[name]) {
                _this.sounds[name].volume(volume);
            }
        });
    };
    SoundService.prototype.changeSoundsVolume = function (volume) {
        var _this = this;
        this.soundOptions.forEach(function (_a) {
            var name = _a.name;
            if (_this.sounds[name]) {
                _this.sounds[name].volume(volume);
            }
        });
    };
    return SoundService;
}());

export { SoundService };
